import React, { Fragment, useState } from "react";
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { store } from "services/state";

export default function ClientCreate(props) {
  let {
    createClientOnboarding,
    setFormData,
    formData,
    errors,
    isEdit
  } = props;

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  };

  const [visible, setVisible] = useState(false);

  return (
    <>
      <Box component='form' onSubmit={createClientOnboarding} sx={{
        '& > div > div' : {
            flex: '0 0 calc(33.333% - 11px)'
          }
      }}>
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          flexWrap: 'wrap', 
          alignItems: 'flex-start', 
           }}>
          <FormControl size='small'>
            <InputLabel id='env-label'>Environment</InputLabel>
            <Select
              required
              labelId='env-label'
              label='Environment'
              name='env'
              value={formData.env}
              onChange={handleChange}
              readOnly={isEdit}
            >
              {store.environmentList.map(opt => (
                <MenuItem key={opt.value || opt.key} value={opt.value}>{opt.text || opt.label || opt.value}</MenuItem>
              ))}
            </Select>
            {errors.env && <div style={{ color: '#d32f2f', fontSize: 12 }}>Please select the env</div>}
          </FormControl>

          <TextField
            required
            label='Client Name'
            name='clientName'
            value={formData.clientName}
            placeholder='client name'
            onChange={handleChange}
            slotProps={{ input: { readOnly: isEdit } }}
            size='small'
            error={!!errors.clientName}
            helperText={errors.clientName}        
          />

          <TextField
            label='Client Email'
            name='clientEmail'
            required
            value={formData.clientEmail}
            placeholder='client email'
            onChange={handleChange}
            size='small'
            error={!!errors.clientEmail}
            helperText={errors.clientEmail}
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 4 }}>
          <FormControl size='small'>
            <InputLabel id='webhook-auth-type-label'>Webhook Auth Type</InputLabel>
            <Select
              labelId='webhook-auth-type-label'
              label='Webhook Auth Type'
              name='webhookAuthType'
              value={formData.webhookAuthType}
              onChange={handleChange}
            >
              <MenuItem value=''>None</MenuItem>
              <MenuItem value='BASIC_AUTH'>Basic Auth</MenuItem>
              <MenuItem value='OAUTH2'>OAuth 2.0</MenuItem>
            </Select>
          </FormControl>

          {(formData.webhookAuthType === 'OAUTH2' || formData.webhookAuthType === 'BASIC_AUTH') && (
            <>
              <TextField
                required
                name='webhookAuthId'
                label='Webhook Username'
                value={formData.webhookAuthId}
                placeholder='Webhook Username'
                onChange={handleChange}
                size='small'
                error={!!errors.webhookAuthId}
                helperText={errors.webhookAuthId}
              />

              <TextField
                required={!isEdit}
                type={visible ? 'text' : 'password'}
                name='webhookAuthSecret'
                label='Webhook Password'
                value={formData.webhookAuthSecret}
                placeholder='Webhook Password'
                onChange={handleChange}
                size='small'
                error={!!errors.webhookAuthSecret}
                helperText={errors.webhookAuthSecret}
                slotProps={{
                  input: {
                    endAdornment: (
                    <IconButton onClick={() => setVisible(!visible)} edge='end'>
                      {visible ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                    )
                  }
                }}
              />
            </>
          )}

          {formData.webhookAuthType === 'OAUTH2' && (
            <>
              <TextField
                required
                name='webhookTokenUrl'
                label='Webhook Token URL'
                value={formData.webhookTokenUrl}
                placeholder='Webhook Token URL'
                onChange={handleChange}
                size='small'
                error={!!errors.webhookTokenUrl}
                helperText={errors.webhookTokenUrl}
              />
              <TextField
                name='webhookContentType'
                label='Webhook Content Type'
                value={formData.webhookContentType}
                placeholder='Webhook Content Type'
                onChange={handleChange}
                size='small'
                error={!!errors.webhookContentType}
                helperText={errors.webhookContentType}
              />
              <TextField
                name='webhookGrantType'
                label='Webhook Grant Type'
                value={formData.webhookGrantType}
                placeholder='Webhook Grant Type'
                onChange={handleChange}
                size='small'
                error={!!errors.webhookGrantType}
                helperText={errors.webhookGrantType}
              />
              <TextField
                name='webhookScope'
                label='Webhook Scope'
                value={formData.webhookScope}
                placeholder='Webhook Scope'
                onChange={handleChange}
                size='small'
                error={!!errors.webhookScope}
                helperText={errors.webhookScope}
              />
            </>
          )}
        </Box>

        <Box sx={{ mt: 4, 
          '& .MuiFormControl-root': {
            width: isEdit ? '100%' : '66%',
          } }}>
          <TextField
            label="Webhook URLs (JSON format)"
            multiline
            rows={6}
            fullWidth
            value={formData.webhooksMap}
            onChange={(e) =>
              setFormData({ ...formData, webhooksMap: e.target.value })
            }
            slotProps={{
              input: {
                sx: {
                  fontFamily: 'monospace',
                },
              },
            }}
            sx={{
              '& textarea': {
                resize: 'vertical'
              },
            }}
          />
        </Box>

        <Box sx={{ mt: 4, 
          '& .MuiFormControl-root': {
            width: isEdit ? '100%' : '66%',
          } }}>
          <TextField
            label="Headers (JSON format)"
            multiline
            rows={3}
            fullWidth
            value={formData.headers}
            onChange={(e) =>
              setFormData({ ...formData, headers: e.target.value })
            }
            slotProps={{
              input: {
                sx: {
                  fontFamily: 'monospace',
                },
              },
            }}
            sx={{
              '& textarea': {
                resize: 'vertical'
              },
            }}
          />
        </Box>

        <Box sx={{ pt: 2 }}>
          <Button disableElevation type='submit' variant='contained' color='primary'>
            {isEdit ? 'Update Client' : 'Onboard Client'}
          </Button>
        </Box>
      </Box>
    </>
  );
}
